import { FC, ReactNode } from "react";
import cx from "apps/website/utils/misc/cx";
import { Theme, themeRootClassMap } from "apps/website/maps/Theme.map";
import {
  getBorderRadiusClass,
  getFlexClasses,
  getGapClasses,
  getPaddingClasses,
  StyleOptions,
} from "libs/utils/sign-up/fresh";
import { getBorderClass } from "libs/utils/sign-up/fresh/styles";

export interface IContentWrapper {
  children: ReactNode;
  backgroundColour?: Theme;
  styleOptions?: StyleOptions;
  id?: string;
  "data-component"?: string;
}
const ContentWrapper: FC<IContentWrapper> = ({
  children,
  backgroundColour = "default",
  styleOptions,
  id,
  "data-component": dataComponent,
}) => {
  const backgroundClass = themeRootClassMap[backgroundColour];
  const paddingClasses = getPaddingClasses(styleOptions);
  const borderRadiusClass = getBorderRadiusClass(styleOptions);
  const flexClasses = getFlexClasses(styleOptions);
  const gapClasses = getGapClasses(styleOptions);
  const borderClasses = getBorderClass(styleOptions);

  return (
    <div
      data-component={dataComponent || ContentWrapper.name}
      data-testid="content-wrapper"
      id={id}
      className={cx(
        "w-full flex",
        borderRadiusClass,
        backgroundClass,
        ...paddingClasses,
        ...flexClasses,
        ...gapClasses,
        ...borderClasses,
      )}
    >
      { children }
    </div>
  );
};

export default ContentWrapper;
